import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext, { ngettext } from '@sdk/lang/gettext';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import Clickable from '@sdk/components/primitives/Clickable';

import LocationChecklistRow from '@web/shifts/LocationChecklist/LocationChecklistRow';

import { LocationChecklistFlag } from './types';

const ContentContainer = styled(Column)`
  max-height: 200px;
  overflow: auto;
  padding-left: 20px;
  margin-bottom: 10px;
`;

const CountContainer = styled(Row)`
  height: 36px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  z-index: 2;
`;

const LocationWrapper = styled(Column)`
  width: 90%;
`;

type Props = {
  userLocations: LocationChecklistFlag[];
  handleLocations: (id: ID, checkboxClicked: boolean) => void;
  checkedLocationsCount: number;
  clearIds: () => void;
};

const LocationChecklistContent: React.FC<React.PropsWithChildren<Props>> = ({
  userLocations,
  handleLocations,
  checkedLocationsCount,
  clearIds,
}) => {
  const checkedLocations = [];
  const uncheckedLocations = [];

  for (const location of userLocations) {
    if (location.checked) {
      checkedLocations.push(location);
    } else {
      uncheckedLocations.push(location);
    }
  }
  return (
    <>
      <ContentContainer>
        <CountContainer>
          <Text12 themeColor={ThemeColorType.gray} uppercase bold>
            {ngettext('%(count)s location', '%(count)s locations', checkedLocationsCount, {
              count: checkedLocationsCount,
            })}
          </Text12>
          {!!uncheckedLocations.length && (
            <Row mRight={15}>
              <Clickable onClick={clearIds}>
                <Text12 themeColor={ThemeColorType.iconGray} uppercase>
                  {gettext('Clear')}
                </Text12>
              </Clickable>
            </Row>
          )}
        </CountContainer>
        <LocationWrapper>
          {checkedLocations.map((location) => (
            <LocationChecklistRow
              key={location.id}
              id={location.id}
              title={location.name}
              isChecked={location.checked}
              handleLocations={handleLocations}
            />
          ))}
          {checkedLocations.length !== userLocations.length && (
            <Row mBottom={10}>
              <HorizontalSeparator themeColor={ThemeColorType.separatorOnGray} />
            </Row>
          )}
          {uncheckedLocations.map((location) => (
            <LocationChecklistRow
              key={location.id}
              id={location.id}
              title={location.name}
              isChecked={location.checked}
              handleLocations={handleLocations}
            />
          ))}
        </LocationWrapper>
      </ContentContainer>
    </>
  );
};
export default LocationChecklistContent;
